/* eslint-disable prettier/prettier */
import studentInsurance from '@/api/student-insurance'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  
}

export const actions = {
  fetch(context, params = {}) {
    return studentInsurance.get({ params })
  },
  failedInsurance(context, params = {}) {
    return studentInsurance.failedInsurance({ params })
  },
  insuranceExcel(context, params = {}) {
    return studentInsurance.insuranceExcel(params)
  },
  acknowledgeInsurance(context, { id, data }) {
    return studentInsurance.acknowledgeInsurance(id, data)
  },
  convertToInsurance(context, { id, data }) {
    return studentInsurance.convertToInsurance(id, data)
  },
  formViewModel(context, params = {}) {
    return studentInsurance.formViewModel({ params })
  }
}
